export const normalizeEmail = (value = '') => value.trim().toLowerCase().replace(/\s+/g, '');

export const isValidEmail = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const hasPasswordSpaces = (value = '') => /\s/.test(value);
